<div class="height-100">
    <div *ngIf="!isCirfExpired">
        <div class="row col-12 padding-top-5 padding-bottom-5 padding-left-0 padding-right-0">
            <div class="row col-12 col-lg-5 padding-left-0">
                <div class="col-12">
                    <span class="header">{{matterTypeText}}: </span>
                    <span *ngIf="!isCustomMatter()" >{{propertyAddressText}}</span>
                    <span *ngIf="isCustomMatter()" >{{legalDescriptionSummary}}</span>
                </div>

            </div>
            <div class="row col-12 col-lg-3 padding-left-0">
                <div class="col-12" *ngIf="closingDateText">
                    <span class="header">{{this.isCustomMatter() ? 'Completing:' : 'Closing:'}}</span>
                    <span>{{closingDateText}}</span>
                </div>
            </div>
            <div class="row col-12 col-lg-4 padding-left-0">
                <div class="col-8" *ngIf="lastSubmittedText">
                    <span class="header">Last submitted:</span>
                    <span>{{lastSubmittedText}}</span>
                </div>
                <div class="non-printable-area padding-right-0" [ngClass]="lastSubmittedText? 'col-4' : 'col-12'">
                    <div class="continue-later-div">
                        <button mat-raised-button color="white" tabindex="0" class="referral-btn" (click)="goToSummaryPage()">
                            <mat-icon>pause</mat-icon>
                            <span>Continue Later</span>
                        </button>
                    </div>

                </div>
            </div>
        </div>
        <div class="row search-block">
            <div class="non-printable-area col-2 d-lg-none" *ngIf="!isCirfExpired">
                <span style="font-size:24px;cursor:pointer" (click)="openNav()">&#9776;</span>
                <div id="cirfSideNav" class="sidenav">
                    <a href="javascript:void(0)" class="closebtn" (click)="closeNav()" >&times;</a>
                    <dp-cirf-side-nav
                            [cirf]="cirf"
                            [isCirfSubmitted]="isSubmitted"
                            [cirfNavigation]="cirfNavigation"
                            (selectSection)="setSelectedTopicAndSection($event)"
                            (addNewMortgage)="addNewMortgage()"
                            (addExistingMortgage)="addExistingMortgage()"
                            (addClient)="addNewClient()"
                    ></dp-cirf-side-nav>
                </div>
            </div>
            <div class="non-printable-area offset-lg-3 col-10 padding-left-0">
                <h3 class="header display-inline">{{selectedSectionTitle}}</h3>
                <div *ngIf="isDeleteClientVisible()" class="display-inline margin-left-10 vertical-align-middle">
                    <span class="d-none d-lg-flex">
                        <button mat-raised-button color="white" tabindex="0" class="referral-btn" (click)="deleteSelectedClient()">
                            <mat-icon>delete</mat-icon>
                            <span>Delete Contact</span>
                        </button>
                    </span>
                    <span class="d-flex d-lg-none">
                        <mat-icon (click)="deleteSelectedClient()">delete</mat-icon>
                    </span>
<!--                    <img src="assets/img/delete.png" alt="delete" title="Delete"-->
<!--                         class="cursor-pointer"-->
<!--                         (click)="deleteSelectedClient()" />-->
                </div>
                <div *ngIf="isDeleteMortgageVisible()" class="display-inline margin-left-10 vertical-align-middle">
                    <span class="d-none d-lg-flex">
                        <button mat-raised-button color="white" tabindex="0" class="referral-btn" (click)="deleteSelectedMortgage()">
                            <mat-icon>delete</mat-icon>
                            <span>Delete Mortgage</span>
                        </button>
                    </span>
                    <span class="d-flex d-lg-none">
                        <mat-icon (click)="deleteSelectedMortgage()">delete</mat-icon>
                    </span>
<!--                    <img src="assets/img/delete.png" alt="delete" title="Delete"-->
<!--                         class="cursor-pointer"-->
<!--                         (click)="deleteSelectedMortgage()" />-->
                </div>
            </div>
        </div>

    </div>
    <div *ngIf="isCirfExpired">
        <div class="row bold-font message" >
            {{message}}
        </div>
    </div>

    <div class="connect-common-page-header padding-left-5 height-80 " *ngIf="!isCirfExpired && !isLoading">

        <div class="row height-100 padding-top-10">
            <div class="d-none d-lg-block col-lg-3 side-nav-div ">
                <dp-cirf-side-nav
                        [cirf]="cirf"
                        [isCirfSubmitted]="isSubmitted"
                        [cirfNavigation]="cirfNavigation"
                        (selectSection)="setSelectedTopicAndSection($event)"
                        (addNewMortgage)="addNewMortgage()"
                        (addExistingMortgage)="addExistingMortgage()"
                        (addClient)="addNewClient()"
                ></dp-cirf-side-nav>

            </div>
            <div class="col-12 col-lg-9 page-content" #pageContent (scroll)="onScrollEvent()">
                <dp-connect-cirf #connectCirf *ngIf="cirfNavigation?.selectedClientIndex >= 0 || cirfNavigation.isClientNotesTopic()"
                                 [clientId]="clients[cirfNavigation.selectedClientIndex]?.id"
                                 [sectionKey]="cirfNavigation.selectedSectionKey"
                ></dp-connect-cirf>

                <dp-matter-property-info *ngIf="cirfNavigation?.isTransactionDetailsTopic()
                                            || cirfNavigation?.isInsuranceSection()
                                            || cirfNavigation?.isMatterNotesSection()
                                            || cirfNavigation?.isAdditionalAttachmentsSection()"
                                         [sectionKey]="cirfNavigation.selectedSectionKey"
                ></dp-matter-property-info>

                <dp-mortgage-form *ngIf="selectedNewMortgage"
                                  [mortgageId]="selectedNewMortgage.id"
                ></dp-mortgage-form>

                <dp-mortgage-form *ngIf="selectedExistingMortgage"
                                  [mortgageId]="selectedExistingMortgage.id"
                ></dp-mortgage-form>

                <dp-new-mortgage-note *ngIf="cirfNavigation?.isNewMortgageNoteSection()"
                ></dp-new-mortgage-note>

                <dp-existing-mortgage-note *ngIf="cirfNavigation?.isExistingMortgageNoteSection()"
                ></dp-existing-mortgage-note>

                <dp-print-cirf *ngIf="cirfNavigation?.isReviewSubmitSection()"
                ></dp-print-cirf>
                <div class="non-printable-area">
                    <div class="row margin-bottom-30 margin-top-30">

                        <div class="row col-12 col-lg-4 padding-left-0">
                            <div class="col-12  padding-bottom-10">
                                <button mat-raised-button
                                        *ngIf="isAddNewClientVisible()"
                                        class="width-100"
                                        (click)="addNewClient()"
                                >Add New Client</button>
                                <button mat-raised-button
                                        *ngIf="isAddNewMortgageVisible()"
                                        class="width-100"
                                        (click)="addNewMortgage()"
                                >Add New Mortgage</button>
                                <button mat-raised-button
                                        *ngIf="isAddExistingMortgageVisible()"
                                        class="width-100"
                                        (click)="addExistingMortgage()"
                                >Add Existing Mortgage</button>

                            </div>
                        </div>

                        <div class="row col-12 col-lg-8 padding-left-0 ">
                            <div class="col-12 offset-lg-4 col-lg-4 padding-bottom-10 float-right" >
                                <button  mat-raised-button *ngIf="isPreviousVisible()"
                                         class="width-100"
                                         (click)="navigatePrev()"
                                ><span class="padding-right-10"><i class="fa fa-chevron-left"></i></span>Previous</button>
                            </div>
                            <div class="col-12 col-lg-4 padding-bottom-10 float-right" *ngIf="isNextVisible() || isSubmitVisible()">
                                <button  mat-raised-button color="accent" *ngIf="isNextVisible()"
                                         class="width-100"
                                         (click)="navigateNext()"
                                         [disabled]="isNextDisabled()"
                                >Next<span class="padding-left-10"><i class="fa fa-chevron-right"></i></span></button>
                                <button mat-raised-button color="accent" *ngIf="isSubmitVisible()"
                                        class="width-100"
                                        (click)="submitCirf()"
                                >Submit</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="back-to-top-block d-12 d-lg-none ">
                    <button id="backToTopBtn" title="Go to top" #backToTopBtn (click)="backToTop()"><i class="fa fa-arrow-up"></i></button>
                </div>

            </div>
        </div>

    </div>

</div>
